import { motion } from "framer-motion";
import { STEPS } from "@/data/site";
import { SectionHead } from "./Reveal";
import { EASE } from "@/lib/scroll";

export const Process = () => (
  <section id="ablauf" data-testid="process-section" className="py-24 lg:py-36 bg-[#111511] text-white rounded-[32px] lg:rounded-[48px] mx-2 sm:mx-4">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHead light eyebrow="So funktioniert es" lines={["In fünf Schritten", <span className="text-[#9CC26A]">zum gepflegten Garten.</span>]}
        text="Unkompliziert vom ersten Kontakt bis zum fertigen Garten – Sie haben dabei immer einen festen Ansprechpartner." />
      <ol className="mt-14 lg:mt-20 grid md:grid-cols-5 gap-4">
        {STEPS.map((s, i) => (
          <motion.li key={s.title} data-testid={`process-step-${i + 1}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, ease: EASE, delay: i * 0.08 }}
            className="group relative rounded-[22px] bg-white/[0.05] border border-white/10 p-6 transition-colors duration-500 hover:bg-white/[0.09] flex md:flex-col gap-5 md:gap-0">
            <span className="shrink-0 w-11 h-11 rounded-full bg-[#9CC26A] text-[#111511] font-head font-semibold flex items-center justify-center">{i + 1}</span>
            <div className="md:mt-14">
              <h3 className="font-head text-lg font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-[#C9CEC6]">{s.text}</p>
            </div>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
